
shadow.loader.init("");
try { frontend.core.init(); } catch (e) { console.error("An error occurred when calling (frontend.core/init)"); throw(e); }